import * as React from 'react';
import { IMediaGalleryImage } from '../classes/media-gallery';

export interface GalleryImageProps {
    data: IMediaGalleryImage;
}

const galleryImageView: React.SFC<GalleryImageProps> = props => {
    var imageStyle = {
        backgroundImage: `url(${props.data.image})`,
    };

    return (
        <div className="item-image-wrapper">
            <div className="item-image" style={imageStyle}></div>
        </div>
    );
}

export default galleryImageView;


// WEBPACK FOOTER //
// ./app/views/gallery-image.tsx